
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FaTrash } from "react-icons/fa";
const ConfirmMultiDelete = ({message, selectedFiles, handleDelete}) => {
    const [isShow, setShow] = useState(false);

    const handleDeleteItem = (id) =>{
        handleDelete(id);
        setShow(false);
    }
  return (
    <>
      <button className='btn btn-danger btn-sm' onClick={()=> setShow(true)}> <FaTrash /> Delete Selected ({selectedFiles.length})</button>
      <Modal
        show={isShow}
        onHide={()=>setShow(false)}
        backdrop="static"
        keyboard={false}
      >
     
        <Modal.Body className='text-center pd-50'>
            {message}
        </Modal.Body>
        <Modal.Footer className='justify-content-center'>
          <button className='btn btn-danger w-100' onClick={()=>setShow(false)}>
            No
          </button>
          <button className='btn btn-primary w-100' onClick={()=>handleDeleteItem(selectedFiles)}>Yes</button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmMultiDelete;